import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OpenClientInvoiceRefundModal, OpenPartialPaidInvoice } from 'store/slices/clientinvoiceSlice';
import { InvoiceRefundDialog } from './CompletedSaleRefundModal';

const RefundFromInvoiceModal = () => {
 const dispatch=useDispatch();
 const invoice=useSelector(state=>state.clientinvoice.isSaleCompletedData);
 const balance=useSelector(state=>state.clientinvoice.isRefundBalance);
 const open=useSelector(state=>state.clientinvoice.isOpenClientInvoiceRefundModal)==='open';
 return <InvoiceRefundDialog invoice={invoice} balance={balance} open={open} close={()=>{
  dispatch(OpenClientInvoiceRefundModal(""));
  dispatch(OpenPartialPaidInvoice(""));
 }}/>;
};
export default RefundFromInvoiceModal;
